import { render, staticRenderFns } from "./details-health.vue?vue&type=template&id=f3ffa352&"
import script from "./details-health.vue?vue&type=script&lang=js&"
export * from "./details-health.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports